export default __webpack_public_path__ + "static/media/48px_discover 1.90b63cd1.svg";